import { buildClientCard } from '../../../shared';

export const sellerCard = buildClientCard({
  id: 'sellerSideContacts.sellersX',
  entityType: 'counterpartyClient',
  label: 'Landlord',
  showSameAsProperty: false,
});
